import React, { useState, useEffect } from 'react';

import { useBreadcrumbs } from '../../hooks';
import useStages from '../shared/hooks/useStages';
import { useLeagues } from '../TeamSelection/useLeagues';
import { useSeasons } from '../TeamSelection/useSeasons';
import useImpacts from './useImpacts';

import StatsTable from './StatsTable';
import { columns } from './options';

const createBreadcrumbs = () => [{ title: 'Stats' }];

const StatsTablePage = () => {
  useBreadcrumbs(createBreadcrumbs, []);

  // leagues
  const leagues = useLeagues();
  const [league, setLeague] = useState();

  const handleLeagueChange = id => {
    id = +id;
    const league = leagues.find(l => l.id === id);
    setLeague(league);
  };
  // seasons
  const seasons = useSeasons(league);
  const [season, setSeason] = useState();
  const handleSeasonChange = id => {
    id = +id;
    const season = seasons.find(l => l.id === id);
    setSeason(season);
  };

  // stages
  const stages = useStages(league && league.id, season && season.id);
  const [stage, setStage] = useState();
  const handleStageChange = id => {
    id = +id;
    const stage = stages.find(l => l.id === id);
    setStage(stage);
  };

  useEffect(() => {
    setSeason(null);
    setStage(null);
  }, [league]);

  const impacts = useImpacts(stage && stage.id, 1500);

  return (
    <StatsTable
      impacts={impacts}
      columns={columns}
      leagues={leagues}
      league={league}
      seasons={seasons}
      season={season}
      stages={stages}
      stage={stage}
      onStageChange={handleStageChange}
      onLeagueChange={handleLeagueChange}
      onSeasonChange={handleSeasonChange}
    />
  );
};

export default StatsTablePage;
